import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoaded: false,
    selectedSection: {},
    selectedSectionId: 0,
    settings: {
      appName: '',
      client: {
        'name': '',
        'main_color': '#ccc',
        'fail_color': '#f00'
      }
    },
    sections: {}
  },
  getters: {
    settings: state => {
      return state.settings
    },
    sections: state => {
      return state.sections
    },
    selectedSection: state => {
      return state.selectedSection
    },
    selectedSectionId: state => {
      return state.selectedSectionId
    },
    isLoaded: state => {
      return state.isLoaded
    }
  },
  mutations: {
    SET_SETTINGS: (state, payload) => {
      state.settings = payload
      document.styleSheets[0].insertRule('.t-bg-color,.main-menu__item--selected:before,.sub-section__title:before,.hero,.medium-editor-toolbar { background-color:' + payload.client.main_color + '!important; }', 0)
      document.styleSheets[0].insertRule('.t-text-color,.selected-item,.body-text a { color:' + payload.client.main_color + '!important; }', 0)
      document.styleSheets[0].insertRule('.loader  { border-top: 6px solid ' + payload.client.main_color + '!important; }', 0)
      Vue.router.app.$Progress.setColor(payload.client.main_color)
      Vue.router.app.$Progress.setFailColor(payload.client.fail_color)
    },
    SET_IS_LOADED: (state, status) => {
      state.isLoaded = status
    },
    SET_SECTIONS: (state, sections) => {
      state.sections = sections
    }
  },
  actions: {
    setIsLoaded: ({commit}, status) => {
      commit('SET_IS_LOADED', status)
    },
    getSettings: ({commit, state, dispatch}, payload) => {
      Vue.axios.get('/settings')
        .then(response => {
          commit('SET_SETTINGS', response.data.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    setSettings: ({commit, state, dispatch}, payload) => {
      commit('SET_SETTINGS', payload)
    },
    setSections: ({commit}, sections) => {
      commit('SET_SECTIONS', sections)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js